<template>
  <div>
    <div class="login-message">
      <div v-if="context.LOGIN_MSG_IS_CUSTOM" v-html="context.LOGIN_MSG"></div>
      <div v-else>Please enter your work email address so that we can connect you with your colleagues</div>
    </div>

    <div class="login-form">
      <div class="form-group">
        <div class="input-group">
          <input
            type="email"
            v-focus
            v-model="email"
            placeholder="you@yourcompany.com"
            @keypress.enter="checkEmail"
            tabindex="1"
            class="form-control input-lg"
          />

          <span class="input-group-btn">
            <button
              class="btn btn-lg btn-primary btn-block"
              :disabled="!canCheckEmail()"
              tabindex="3"
              @keypress.enter="checkEmail"
              @click="checkEmail()"
            >
              <digital-event-preloader type="container" :active="isLoading" />
              <i class="fa fa-fw fa-lg fa-arrow-right"></i>
            </button>
          </span>
        </div>
      </div>
    </div>

    <div v-if="context.TNC_REQUIRED" class="tnc-message">
      By logging in here you agree to our event
      <modal-window-link
        modal-window-name="iframe-modal-window"
        link-text="T&C"
        :context="{ url: context.TNC_URL, title: 'Terms and Conditions' }"
      >
      </modal-window-link
      >:
      <input type="checkbox" name="termsAndConditionsField" v-model="termsAndConditions" tabindex="2" />
    </div>
  </div>
</template>

<script>
import AuthMixin from "./mixins/AuthMixin";
import NotificationsMixin from "../mixins/NotificationsMixin";
import { EMAIL_REGEXP } from "@/helpers/constants";
import { mapState, mapGetters } from "vuex";

export default {
  name: "Login",
  mixins: [AuthMixin, NotificationsMixin],
  data() {
    return {
      email: "",
      termsAndConditions: false
    };
  },
  computed: {
    ...mapState("event", ["context"]),
    ...mapGetters(["isLoading"])
  },
  methods: {
    /**
     * Validate email
     * @param email
     * @return {*|boolean}
     */
    validEmail(email) {
      return EMAIL_REGEXP.test(email);
    },
    /**
     * Check, that user put correct email and accept terms and conditions
     * @return {string|*|boolean}
     */
    canCheckEmail() {
      return this.email && this.validEmail(this.email) && (this.context.TNC_REQUIRED ? this.termsAndConditions : true);
    },
    /**
     * Check, that email exists in DB
     * @return {Promise<void>}
     */
    async checkEmail() {
      if (!this.canCheckEmail()) return;

      await this.submitEmail();
    },

    /**
     * Send request to the server for checking email address
     * @return {Promise<void>}
     */
    async submitEmail() {
      let { messages, errors, userDisabled, newUser, userInfo } = await this.$store.dispatch(
        "users/getUserInfoByEmail",
        {
          email: this.email
        }
      );

      this.showMessages(messages);
      this.showErrors(errors);

      if (userDisabled) {
        this.showNotification({
          type: "error",
          message:
            "Your account is currently disabled. You will not be able to access this event. " +
            "Please get hold of your event contact."
        });
      } else if (newUser) {
        this.goTo(this.ROUTES.DIGITAL_EVENT_AUTH_CREATE_ACCOUNT);
      } else if (userInfo) {
        this.goTo(this.ROUTES.DIGITAL_EVENT_AUTH_SET_PASSWORD);
      }
    }
  }
};
</script>
